import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import clearIcon from "../images/clear.png";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import {setChangedMaterial} from "../features/workspaceDataSlice"
import Tooltip from '@mui/material/Tooltip';

const WorkspaceTableHeader = (props) => {
  const {updateNetzeroPopupData} = props;
  const {clearAllData,popupData,openDialog} = props;
    const [alignment, setAlignment] = React.useState("Material");
    
    const {materials,region,scenario,changedMaterial} = useSelector((state)=>state.workspaceData);
    const dispatch = useDispatch();
   
    const handleSelectionChange = (event, value) => {
    dispatch(setChangedMaterial(value));
    updateNetzeroPopupData(scenario,value);
    };
    const handleToggleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
      };
    


    return (
        <div class="workspace-actions">
        <div>
          <ToggleButtonGroup
            color="primary"
            value={alignment}
            exclusive
            onChange={handleToggleChange}
            aria-label="Platform"
          >
            <ToggleButton value="Material">
              {" "}
              Material
            </ToggleButton>
            <Tooltip title="Targeted For Future Release">
              <ToggleButton value="Building">
                {" "}
                Building Element
              </ToggleButton>
            </Tooltip>
          </ToggleButtonGroup>
        </div>
        <div class="filter-actions">
          <Box className="auto-complete">
            <label>Material</label>
            <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={materials}
      sx={{ width: 300 }}
     value={changedMaterial}
      onChange={handleSelectionChange}
      defaultValue={changedMaterial && materials && materials.length > 0 ? changedMaterial : (materials && materials.length > 0 && materials[0])}
      isOptionEqualToValue={(option, value) => option.label === value}
      renderInput={(params) => <TextField {...params} />}
    />
          </Box>
          <Box className="checkbox">
          { region && ((region === "AU") || (region === "Australia")) && (scenario === "Stretch"  || scenario === "Moderate"|| scenario === "Innovation") &&
         
            <FormControlLabel
              control={<Checkbox />}
              label="Carbon Neutral"
              name="carbonNeutral"
              checked ={popupData.carbonNeutral}
              onChange={openDialog}
            />
          }
          { (scenario === "Stretch" || scenario === "Innovation") &&
           <FormControlLabel
              control={<Checkbox />}
              label="Design Efficiency"
              name="designEfficiency"
              checked ={popupData.designEfficiency}
              onChange={openDialog}
            />
          }
        
          </Box>
          <Box className="button">
            <Button variant="outlined" onClick = {clearAllData}>
              <img src={clearIcon} alt="Edit Details" />
              Clear All Data
            </Button>
            {
              scenario === "Base" &&  <Button variant="outlined" name="editBtn" onClick = {openDialog}>Edit</Button>
            }
           
          </Box>
        </div>
      </div>

        
        )
}

export default WorkspaceTableHeader;